import { useEffect, useState } from "react";
import { post } from "../js/post";
import { userData, selectedOptic, formatValueUnit } from "../js/utils";
import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import TooltipBox from "./Tooltip";
import {
  ASPatientsAppointments,
  ASPatientsBirthday,
  ASPatientsCheckUps,
  ASPatientsCommunications,
} from "../js/tableColumns";

export function AutoSendPatients({
  category,
  total,
  channel,
  auto,
  createPopupQuestion,
  removePopupQuestion,
  onSend,
}) {
  const [patientsList, setPatientsList] = useState([]);
  const [patientsListFixed, setPatientsListFixed] = useState([]);

  // console.log("patientsList: ", patientsList);
  // console.log("patientsListFixed: ", patientsListFixed);

  async function getAutoSendPatients() {
    const response = await post(
      "support-extra/crm/ObtenerPacientesAutosendsVerMas.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        categoriaAutosend: category,
      },
    );
    setPatientsList(response);
  }

  async function sendPatients() {
    const response = await post("support-extra/crm/EnviarAutosend.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      pacientes: patientsListFixed,
      categoriaAutosend: category,
    });
    // console.log(
      // "ENVIOS AUTOSEND: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // pacientes: patientsListFixed,
        // categoriaAutosend: category,
      // },
      // response,
    // );
    createPopupQuestion(
      response.error === ""
        ? `${formatValueUnit(patientsListFixed.length)} envíos realizados correctamente.`
        : response.error,
      async () => {
        onSend();
        removePopupQuestion();
      },
      null,
      "Entendido",
    );
    if (response.error === "") await getAutoSendPatients();
  }

  function removePatient(id) {
    setPatientsList((prev) => prev.filter((e) => e.idCliente !== id));
  }

  const columnsByCategory = {
    Cumpleanos: ASPatientsBirthday,
    RecordatorioCitas: ASPatientsAppointments,
    RevisionesOptometria: ASPatientsCheckUps,
    RevisionesLC: ASPatientsCheckUps,
    RevisionesAudiometria: ASPatientsCheckUps,
    ComunicacionTrasVenta: ASPatientsCommunications,
    ComunicacionTrasVentaGafas: ASPatientsCommunications,
    ComunicadoTrasVentaLC: ASPatientsCommunications,
    ComunicadoTrasVentaAudifono: ASPatientsCommunications,
  };

  const columns = columnsByCategory[category] ?? [];

  const columnsWithInputs = columns.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        selector: (row) =>
          !auto && row.estado === "Pendiente" ? (
            <>
              <img
                src={`/images/remove-blue.svg`}
                className="icon-pref"
                alt="Eliminar producto"
                data-tooltip-id={row.idCliente}
                onClick={() => {
                  createPopupQuestion(
                    `¿Desea eliminar el paciente?`,
                    async () => {
                      removePatient(row.idCliente);
                      removePopupQuestion();
                    },
                    removePopupQuestion,
                    "Sí",
                    "No",
                  );
                }}
              ></img>
              <TooltipBox
                id={String(row.idCliente)}
                content={
                  <div className="opt-table-tooltip grid-5">
                    <div className="cell combined-cells-5 cell-start-content">
                      Borrar
                    </div>
                  </div>
                }
              ></TooltipBox>
            </>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  useEffect(() => {
    getAutoSendPatients();
  }, [category]);

  useEffect(() => {
    setPatientsListFixed(
      patientsList
        .filter((e) => e.estado === "Pendiente")
        .map((e) => e.idCliente),
    );
  }, [patientsList]);

  return (
    <>
      <div className="container-panel">
        <div className="opt-table-content grid-8" id="autosend-summary-grid">
          <div className="cell cell-label cell-start-content">Canal</div>
          <div className="cell cell-start-content">{channel}</div>
          <div className="cell combined-cells-6"></div>
        </div>
        {patientsList.length > 0 && (
          <div
            className="opt-table-title"
            style={{ marginTop: 20, marginBottom: 10 }}
          >
            <div>
              Listado de pacientes ({formatValueUnit(patientsList.length)})
            </div>
          </div>
        )}
        <DataTable
          columns={columnsWithInputs}
          data={patientsList}
          className="custom-datatable autosend-patients-table"
          noDataComponent="No hay pacientes disponibles."
        />
        {!auto && (
          <div
            style={{ marginTop: 20, display: "flex", justifyContent: "center" }}
          >
            <ButtonIconH
              text="Enviar"
              small={true}
              onClick={async () => {
                if (patientsListFixed.length > 0) {
                  createPopupQuestion(
                    `Se van a realizar un total de ${formatValueUnit(patientsListFixed.length)} envíos a los pacientes cuyo estado es "Pendiente". ¿Desea continuar?`,
                    async () => {
                      removePopupQuestion();
                      await sendPatients();
                    },
                    removePopupQuestion,
                    "Sí",
                    "No",
                  );
                }
              }}
            ></ButtonIconH>
          </div>
        )}
      </div>
    </>
  );
}
